import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/FormModal";
import ModenatoePageForm from "./ModenatoePageForm";

const AddModeratorPage = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Add_ModeratorPage_Modal, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <FormModal
      addButtonName="Add New"
      modalTitle="Add"
      submitButtonText="Save"
      cancelButtonText="Cancel"
      apiMethod="POST"
      addApiName="addStaticPage"
      addApiRequest="AddRecord"
      apiLoader="StartSpinner"
      ModalName="Add_ModeratorPage_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={Add_ModeratorPage_Modal ? Add_ModeratorPage_Modal : false}
      width={500}
      form={form}
      recordName="moderatorPageList"
      extraFieldName="portal"
      extraFieldValue="moderator"
    >
      <ModenatoePageForm />
    </FormModal>
  );
};

export default AddModeratorPage;
